<template>
  <div id="page-container" class="sidebar-o enable-page-overlay side-scroll page-header-fixed sidebar-inverse">
    <sidebar />
    <page-header />

    <main id="main-container">
      <router-view/>
    </main>
  </div>

</template>
<script>
import Sidebar from '@/components/app/admin/Sidebar';
import SideOverlay from '@/components/app/admin/SideOverlay';
import PageHeader from '@/components/app/admin/PageHeader';
export default {
  name: 'admin-layout',
  components: {
    Sidebar,
    SideOverlay,
    PageHeader,
  },
}
</script>
